import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { default as config } from '../../../constants/constants';
import { PersonalPodcast } from '../types/podcast';

export const getPersonalPodcasts = async (
  token: string
): Promise<AxiosResponse<PersonalPodcast[]>> => {
  const options: AxiosRequestConfig = {
    method: 'GET',
    headers: {
      'X-Firebase-Auth': token
    },
    url: `${config.serverURL}/user/personalPodcast`
  };

  return axios(options);
};
